<template>
  <div
    class="text-right align-center"
    style="height:55px"
  >
    <span class="left subtitle-1 ml-2 mt-2">{{ title }}</span>
    <v-btn
      text
      class="ma-0 pa-0"
      style="min-width: 55px;"
      @click="$emit('del')"
    >
      <v-icon small>
        {{ IconEnum.minus }}
      </v-icon>
    </v-btn>
    <span
      class="headline mx-2"
    >{{ value }}</span>
    <v-btn
      text
      class="ma-0 pa-0"
      style="min-width: 55px;"
      @click="$emit('add')"
    >
      <v-icon small>
        {{ IconEnum.plus }}
      </v-icon>
    </v-btn>
  </div>
</template>

<script>
import { IconEnum } from '@/modules/Enums'

export default {
  name: 'EcocupCounter',

  props: {
    value: { type: Number, default: 0 },
    title: { type: String, default: '' }
  },

  data () {
    return {
      IconEnum
    }
  }
}
</script>
